/* eslint-disable */

export const sentVolumeSell = {
    GET_SENT_VOLUME_SELL_REQUEST: 'GET_SENT_VOLUME_SELL_REQUEST',
    GET_SENT_VOLUME_SELL_SUCCESS: 'GET_SENT_VOLUME_SELL_SUCCESS',
    GET_SENT_VOLUME_SELL_FAILURE: 'GET_SENT_VOLUME_SELL_FAILURE',
};
